import { Loader } from 'shared-components';
import React from 'react';

export const Spinner = () => <Loader />;
